<!-- About Hero Section -->
<section id="about-hero" class="w-100 text-light"
  style="margin-top: 66px; background: linear-gradient(45deg, #1A2042, #173580);">
  <div class="container py-5 text-center">
    <h1 class="fw-bold mb-4">About Us</h1>
    <p class="lead mb-4">
      At ChalkBasket, we are a group of passionate software professionals committed to bridging the gap between academic
      learning and industry-ready skills.
    </p>

  </div>
</section>

<!-- About Intro Section -->
<section class="py-5 my-5">
  <div class="d-flex flex-column flex-lg-row gap-5 align-items-center">

    <!-- Left: Text -->
    <div class="flex-grow-1 pe-lg-5 text-center text-lg-start ps-lg-4">
      <h2 class="fw-bold mb-4 text-center">About Us</h2>
      <hr>
      <p class="lead text-muted  p-2">
        At <strong>ChalkBasket</strong>, we are a group of passionate software professionals with <strong>15+ years of real-world
          industry experience</strong>. Having worked across leading technologies, domains, and global organizations, we
        have seen firsthand the gap between academic learning and the practical skills required to thrive in today’s competitive job market.
      </p>
      <h6 class="fw-semibold mb-4">
        Our mission is simple yet powerful: <strong>To train, mentor, and guide fresh graduates and undergraduates to
          land the job they truly
          deserve.</strong>
      </h6>

    </div>

    <!-- Right: Image -->
    <div class="flex-grow-1 d-none d-sm-block">
      <img
        src="https://plus.unsplash.com/premium_photo-1668383778557-d71c562fdb4b?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        alt="Our Team Photo" class="rounded-3 p-2 img-fluid shadow pt-3" style="width:1200px ;">
    </div>

  </div>
</section>


<!-- here put the Who We Are --><!-- Who We Are Section -->
<section class="py-5 my-5">
  <div class="d-flex flex-column flex-lg-row gap-5 align-items-center">

    <!-- Left: Text -->
    <div class="flex-grow-1 pe-lg-5 text-center text-lg-start p-2">
      <h2 class="fw-bold mb-4 text-center">Who We Are</h2>
      <hr>
      <p class="lead text-muted mb-3 p-2 text-center" style=" color: #64748b;
  line-height: 1.6;
  font-size: 1rem;font-weight: 700;">
        We are not just trainers—we are mentors. With extensive experience in software development, project delivery,
        and technology leadership, our team brings practical insights, industry best practices, and career wisdom to the
        classroom.
      </p>
    </div>

    <!-- Right: Image -->


  </div>
</section>


<!-- Mission & Vision Section -->
<section id="mission-vision-values" class="py-5 px-4 my-5">
  <h2 class="text-center mb-4 fw-bold">Mission & Vision</h2>
  <p class="text-center mb-4 text-muted">Guiding principles that shape our purpose and empower learners every day.</p>
  <hr class="my-4">

  <div class="row mt-4 g-4 justify-content-center">
    <div class="col-lg-6 col-md-8">
      <div class="feature-card">
        <div class="feature-icon">
          <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Purpose Icon">
        </div>
        <h3>Our Mission</h3>
        <p>To create a supportive learning ecosystem where students not only acquire technical knowledge but also gain the confidence, mindset, and skills to succeed in their careers.</p>
      </div>
    </div>

    <div class="col-lg-6 col-md-8">
      <div class="feature-card">
        <div class="feature-icon">
          <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Future Icon">
        </div>
        <h3>Our Vision</h3>
        <p>To bridge the skill gap between education and industry, empowering students to become job-ready professionals who stand out in the global talent market.</p>
      </div>
    </div>
  </div>
</section>

<!-- What We Do Section -->
<section class="section  p-1 fade-in">
  <h2 class="section-title">What We Do</h2>
  <hr>
  <div class="services-grid">
    <div class="service-item">
      <h4>🛠️ Hands-On Training Workshops:</h4>
      <p>Focused on real-world requirements and problem-solving.</p>
    </div>
    <div class="service-item">
      <h4>🎓 Mentorship:</h4>
      <p>Guidance to help students identify strengths and career paths.</p>
    </div>
    <div class="service-item">
      <h4>💼 Job Readiness</h4>
      <p>Interview preparation, communication skills, and professional etiquette.</p>
    </div>
    <div class="service-item">
      <h4>🚀 Latest Technologies:</h4>
      <p>Mentorship on preparation for cutting-edge tools, frameworks, and industry practices that employers seek.</p>
    </div>
  </div>
</section>

<!-- Why Choose Us Section -->
<section id="about" class="p-5" style="background: #eeedde; color: black">
  <div class="d-flex flex-column flex-lg-row-reverse gap-4 align-items-center aboutSection">
    <div class="flex-grow-1">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDyxxzO-EN4RklWgjEZ-mb7xGBDD_fmYViBg&s"
        alt="Team Picture" class="rounded-3 img-fluid shadow-lg border border-light" />
    </div>
    <div class="flex-grow-1 pe-lg-5">
      <h3 class="mb-3 fw-bold">Why Choose Us?</h3>
      <ul class="mb-4 text-muted">
        <li>15+ years of proven software industry expertise</li>
        <li>Practical, project-based learning approach</li>
        <li>Personalized mentoring and career guidance</li>
        <li>Focus on both technical excellence and soft skills</li>
        <li>Strong network of industry connections to support career growth</li>
      </ul>
      <p class="lead text-muted">
        At <strong>ChalkBasket</strong>, we don’t just prepare students for interviews—we prepare them for <strong>careers</strong>.
      </p>
    </div>
  </div>
</section>

<!-- Call-to-Action Section -->
<section id="cta" class="d-flex flex-column align-items-center py-5 px-4"
  style="background: linear-gradient(45deg, #0e0e0e, #111318); color: #fff;">
  <h2 class="mb-4 pb-3">Ready to Start?</h2>
  <p class="mb-4">Join thousands of students who are learning and earning with us.</p>
  <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3"
    (click)="navigateAndScroll('/home',0,400)">Register Now</button>
</section>